<template lang="pug">
  #app
    Header
    .main
      router-view
    Footer(v-if='$route.path != "/home"')
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="sass">
*
  padding: 0
  margin: 0
img
  display: block
html, body
  color: #2d292a
#app
  display: flex
  flex-direction: column
  min-height: 100vh
.main
  width: 100%
  box-sizing: border-box
  min-height: calc(100vh - 196px)
  flex: 1
.fade-enter-active, .fade-leave-active
    transition: opacity 2s
.fade-enter, .fade-leave-to
    opacity: 0
</style>
